import React from "react";
import { Title } from "../../components/Title";
import { CardThree } from "../../components/Card/CardThree";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const DeveloperSecurity = () => {
  const { t } = useTranslation();
  const cards = [
    {
      title: `${t("developer.security.item-one.title")}`,
      subtitle: `${t("developer.security.item-one.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/authentication/mfa/totp.html",
    },
    {
      title: `${t("developer.security.item-two.title")}`,
      subtitle: `${t("developer.security.item-two.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/security/config-domain.html",
    },
    {
      title: `${t("developer.security.item-three.title")}`,
      subtitle: `${t("developer.security.item-three.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/security/config-password.html",
    },
    {
      title: `${t("developer.security.item-four.title")}`,
      subtitle: `${t("developer.security.item-four.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/migrations/custom-password-script/",
    },
  ];
  return (
    <div>
      <section className="developer-security" id="security">
        <div className="inner">
          <Title title={t("developer.security.title")}></Title>
          <div className="developer-content">
            {cards.map((item) => {
              return <CardThree title={item.title} subtitle={item.subtitle} link={item.link} />;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
